import React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import clsx from "../../util/clsx"

const useStyles = makeStyles(theme => ({
  video: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 0,
    opacity: 0.3,
  },
}))

const BackgroundVideo = ({
  vidCustomStyle,
  poster,
  title,
  _mp4_src,
  _webm_src,
}) => {
  const classes = useStyles()
  return (
    <video
      className={clsx([classes.video, vidCustomStyle && vidCustomStyle])}
      playsInline
      autoPlay
      muted
      loop
      title={title && title}
      poster={poster && poster}
      id="bgvideo"
    >
      {_webm_src && <source src={_webm_src} type="video/webm" />}
      {_mp4_src && <source src={_mp4_src} type="video/mp4" />}
    </video>
  )
}

export default BackgroundVideo
